import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "modalClose",
  "use": "modalClose-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 23 23\" id=\"modalClose\">\n<style type=\"text/css\">\n\t#modalClose .st0{fill:none;stroke:#9C7446;stroke-miterlimit:10;}\n</style>\n<g>\n\t<line class=\"st0\" x1=\"0.6\" y1=\"22.4\" x2=\"22.4\" y2=\"0.5\" />\n\t<line class=\"st0\" x1=\"8.4\" y1=\"8.5\" x2=\"0.6\" y2=\"0.5\" />\n\t<line class=\"st0\" x1=\"22.3\" y1=\"22.5\" x2=\"14.5\" y2=\"14.5\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol